<template>
  <div>
    <WorkFLow ref="workflowRef" :permisionOption="permisionOption" />
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import WorkFLow from '@/components/workflow/workflow.vue';
import { saveProcessDesign, getProcessDesignData } from '@/api/tempApproval';
import { getconditionsUseData } from './util';
export default {
  name: 'Workflow',
  props: {
    permisionOption: {
      type: Array,
      defualt: () => []
    },
    type: {
      type: String,
      default: 'create'
    },
    id: {
      type: String,
      default: ''
    }
  },
  components: { WorkFLow },
  data() {
    return {
      initData: {
        nodeId: uuidv4(),
        error: true,
        nodeName: '发起人',
        nodeType: 0,
        userType: 1,
        nodeExecUsers: [],
        nodeUserList: []
      }
    };
  },
  methods: {
    init() {
      if (this.type == 'create') {
        const workflowDom = this.$refs.workflowRef;
        workflowDom.setInitData(this.initData);
      } else if (this.type == 'edit') {
        this.getDetail();
      }
    },
    submitWorkflow(procTplConfigId) {
      return new Promise(resolve => {
        const workflowDom = this.$refs.workflowRef;
        const procModelDef = workflowDom.getSubmitData();
        const conditionsUseing = getconditionsUseData(procModelDef);
        if (!procModelDef) {
          return false;
        }
        const data = {
          procModelDef,
          procTplConfigId,
          procNodeAuth: {
            conditionsUseing
          }
        };
        saveProcessDesign(data).then(res => {
          const { code } = res.data;
          if (code == 200) {
            resolve(conditionsUseing);
          }
        });
      });
    },
    async getDetail() {
      const res = await getProcessDesignData(this.id);
      const { data } = res.data;
      const { procModelDef, procNodeAuth = {} } = data;
      const workflowDom = this.$refs.workflowRef;
      workflowDom.setInitData(procModelDef || this.initData);
      const { conditionsUseing = [] } = procNodeAuth || {};
      this.$emit('on-created', conditionsUseing);
      // 在编辑的时候，把对应的赋值permissionOption
      // 下面以后可能会用到选择发起人的时候用
      // if (procModelDef && procModelDef.nodeType == 0) {
      //   const { nodeUserList = [] } = procModelDef;
      //   console.log(nodeUserList);
      //   workflowDom.setPromoterSelect(nodeUserList);
      // }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less" scoped></style>
